import React, { useState, useRef }  from 'react'
import moment from "moment";
import Select from "react-select";
import * as Yup from "yup";
import { Field, Formik } from "formik";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import  ProviderDrawer  from './ProviderDrawer';
import Drawer from 'components/Drawer';
import ErrorBoundary from "components/ErrorBoundary";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import Calendar from "assets/icon/calendar-icon.svg";
import{pharmcyOptions} from "pages/commonData";
import { ErrorMessage } from "formik";

const validationSchema = Yup.object({
  pharmacyname: Yup.string().required("Pharmacy is required"),
});
const entity = [];
const coveredEnitity = "";
const initialValues = {
  thirdparty: "",
  entityname: "",
  pharmacyname: "",
};

const pharmcyNameOption = [...pharmcyOptions];

const SearchBiTool = ({ onSearch, onReset }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());  
  const [isOpen, setOpen] = useState(false); 
  const[providerCount,setProviderCount]=useState(0);
  const [errorMessage, setErrorMessage] = useState('');

  const formikRef = useRef();

  const setCount=(count)=>{
    setProviderCount(count);
  };


  const toggleProviderDrawer = () => {
    setOpen(!isOpen);
  };
  const handleReset = ({ resetForm }) => {
    resetForm();
    setProviderCount(0);
    setErrorMessage('');

    onReset();
    // updateStates(merge(claimsManager, claimsInitialValues));
  };

  const handleSubmit = async (val, actions) => {
    setErrorMessage('');
    if (providerCount==0) return setErrorMessage('Select Provider NPIs');
    console.log({ val });
    onSearch();
  };

  return (
      <Formik
        onSubmit={handleSubmit}
        enableReinitialize={true}
        initialValues={initialValues} 
        children={(props) => {
          const {
            isSubmitting,
            handleSubmit,
            resetForm,
            setFieldValue,
            errors,
            touched,
          } = props;
          return (
            <div>
              <h5 className="f-15 text-primary font-weight-700">
                BI Tool
              </h5>
              <Row>
              <Col md={2} sm={3} xs={6}>
                <FormGroup>
                    <Label for="providerNpi">Provider NPIs</Label>
                    <Input
                      id="providerNpi"
                      name="providerNpi"
                      className='required'
                      readOnly
                      value={`${providerCount} Providers Selected`}
                      onClick={() => toggleProviderDrawer()}
                    />
                    {errorMessage && providerCount==0 && (
                      <div className="text-danger f-10 position-absolute">{errorMessage}</div>
                    )}
                    <Drawer
                      direction="end"
                      isOpen={isOpen}
                      toggle={toggleProviderDrawer}
                      title="Providers"
                    >
                      <ErrorBoundary>
                        <ProviderDrawer
                          providerCount={providerCount}
                          setCount={setCount}
                          onClose={toggleProviderDrawer} />
                      </ErrorBoundary>
                    </Drawer>
                </FormGroup>
              </Col>
              {/* <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="pharmacyname">Pharmacy</Label>
                    <Field
                      name="pharmacyname"
                      type="text"
                      className="required"
                      component={FormikSelectField}
                      options={pharmcyNameOption}
                      defaultoption="--Select--"
                      keys={{
                        id: "id",
                        label: "label",
                      }}
                    />
                  </FormGroup>
                </Col> */}
                <Col md={2} sm={3} xs={6}>
                    <FormGroup>
                      <Label>Start Date</Label>
                      <InputGroup>
                        <Field
                          type="text"
                          id="startDate"
                          name="startDate"
                          autoComplete="off"
                          placeholder="Select a date"
                          value={startDate}
                          component={FormikDatePicker}
                          //   onChange={handleStartDate}
                        />
                        <InputGroupText
                        //   onClick={() => handleDateClick("startDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col xs="auto" className="mt-3 pt-3">
                    {' '}
                    <FormGroup>
                      <Label className="pt-1">-</Label>
                    </FormGroup>
                  </Col>
                  <Col md={2} sm={3} xs={6}>
                    <FormGroup>
                      <Label>End Date</Label>
                      <InputGroup>
                        <Field
                          type="text"
                          id="endDate"
                          name="endDate"
                          autoComplete="off"
                          placeholder="Select a date"
                          value={startDate}
                          component={FormikDatePicker}
                          //   onChange={handleStartDate}
                        />
                        <InputGroupText
                        //   onClick={() => handleDateClick("startDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </FormGroup>
                  </Col>{' '}
                  
                
                
                <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="ms-3"
                  >
                    Search
                  </Button>
                  <Button color="primary" onClick={() => handleReset(props)}>
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    );
}

export default SearchBiTool